import React from 'react';
import PropTypes from 'prop-types';
import { connectAdvanced } from 'react-redux';
import { Button } from 'react-md';

const FlatOrIconButton = ({ children, ...props }) => (
  <Button
    flat
    primary
    {...props}
  >
    {children}
  </Button>
);

FlatOrIconButton.propTypes = {
  children: PropTypes.node.isRequired,
};

export default connectAdvanced(() => (state, props) => ({ ...props}))(FlatOrIconButton);


// WEBPACK FOOTER //
// ./src/containers/Shared/FlatOrIconButton.js